(function () {
  function initNutriDialog() {
    var dialog = document.getElementById('pots-nutri-dialog');
    if (!dialog) return;
    if (dialog.parentNode !== document.body) document.body.appendChild(dialog);

    var trigger = document.querySelector('#pots-nutri-btn-wrap .pots-nutri-trigger');
    if (trigger) {
      trigger.addEventListener('click', function () {
        if (typeof dialog.showModal === 'function') {
          try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
        } else {
          dialog.setAttribute('open', '');
        }
        document.body.style.overflow = 'hidden';
      });
    }

    var closeBtn = dialog.querySelector('.pots-nutri-close');
    function closeDlg() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDlg);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDlg(); });
    dialog.addEventListener('close', function () { document.body.style.overflow = ''; });

    function reposition() {
      var b = document.getElementById('pots-nutri-btn-wrap');
      if (!b) return;
      var fp = document.querySelector('.featured-product');
      if (!fp) return;
      var g = fp.querySelector('.product__media-wrapper');
      var i = fp.querySelector('.product__info-container');
      if (!g || !i) return;
      if (window.innerWidth >= 750) {
        if (b.parentNode !== g) g.appendChild(b);
      } else {
        if (b.parentNode !== i) i.insertBefore(b, i.firstChild);
      }
    }
    reposition();
    window.addEventListener('resize', reposition);
  }

  function cleanOnetimeLabel() {
    var lbl = document.getElementById('onetime-label');
    if (!lbl) return;
    var del = lbl.querySelector('del');
    if (!del) return;
    var originalPrice = del.textContent.trim();
    var m = lbl.textContent.match(/^(.+?)\s*-\s*\$/);
    var labelText = m ? m[1].trim() : 'One-Time Purchase';
    lbl.innerHTML = '<u style="color:#000;text-decoration:underline;text-underline-offset:2px;">' + labelText + ' - ' + originalPrice + '</u>';
  }

  function initOnetimeLabel() {
    cleanOnetimeLabel();
    var lbl = document.getElementById('onetime-label');
    if (lbl && window.MutationObserver) {
      new MutationObserver(cleanOnetimeLabel).observe(lbl, { childList: true, subtree: true, characterData: true });
    }
  }

  function init() {
    initNutriDialog();
    initOnetimeLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();
